import {gql, MutationHookOptions, useMutation} from '@apollo/client';

interface Vars {
	appt: string;
	hold: string;
	init: boolean;
}

interface Result {
	payment: {
		id: string;
		hold: {
			id: string;
			error?: string;
			remaining?: number;
			created?: string;
		}
	}
}

const query = gql`
mutation ($appt: ID!, $hold: ID!, $init: Boolean!) {
	payment {
		id
		hold(appt: $appt, hold: $hold, init: $init) {
			id
			error
			remaining
			created
		}
	}
}`;

export const useHold = (options: MutationHookOptions<Result, Vars>) => {
	return useMutation<Result, Vars>(query, {
		...options,
	});
};
